import { msg } from "@lit/localize";
import { createAsyncAction, createAsyncActionGroup } from "@progressive-development/pd-spa-helper";
import type { bookmark } from "@progressive-development/politik-model";

/**
 * Async-Actions der Merkliste (Abschnitt 3: Drucksachen/Sitzungen bookmarken,
 * mit eigener Notiz). Load ohne Payload; add/update/delete als Groups mit
 * Payload. Alle Groups sind in common/store/app-loading-effects.ts registriert.
 */

export const loadBookmarks = createAsyncAction<bookmark.Bookmark[]>("LOAD_BOOKMARKS", {
  loadingTxt: msg("Merkliste wird geladen…", { id: "app.bookmarks.loading.toast" }),
  smallBackground: true,
});

export const addBookmark = createAsyncActionGroup<bookmark.AddBookmark, bookmark.Bookmark>(
  "ADD_BOOKMARK",
  {
    loadingTxt: msg("Wird gemerkt…", { id: "app.bookmarks.adding.toast" }),
    successTxt: msg("Zur Merkliste hinzugefügt.", { id: "app.bookmarks.added.toast" }),
    modal: true,
  },
);

/** Update braucht id UND Patch — der Payload bündelt beides. */
export interface UpdateBookmarkPayload {
  id: string;
  patch: bookmark.UpdateBookmark;
}

export const updateBookmark = createAsyncActionGroup<UpdateBookmarkPayload, bookmark.Bookmark>(
  "UPDATE_BOOKMARK",
  {
    loadingTxt: msg("Notiz wird gespeichert…", { id: "app.bookmarks.saving.toast" }),
    successTxt: msg("Notiz gespeichert.", { id: "app.bookmarks.saved.toast" }),
    modal: true,
  },
);

export const deleteBookmark = createAsyncActionGroup<string, bookmark.DeletedBookmark>(
  "DELETE_BOOKMARK",
  {
    loadingTxt: msg("Wird entfernt…", { id: "app.bookmarks.deleting.toast" }),
    successTxt: msg("Von der Merkliste entfernt.", { id: "app.bookmarks.deleted.toast" }),
    modal: true,
  },
);
